__turbopack_context__.v({
  "Checkbox": "Checkbox-module__0KNGSW__Checkbox",
  "CheckboxChecked": "Checkbox-module__0KNGSW__CheckboxChecked",
  "CheckboxIcon": "Checkbox-module__0KNGSW__CheckboxIcon",
  "CheckboxIconChecked": "Checkbox-module__0KNGSW__CheckboxIconChecked",
});
